import { t } from '@lingui/macro'
import { PlanningOverviewDto } from '@/core/models/planning.model'

export function getPlanningOverviewStatusLabel(planning: Pick<PlanningOverviewDto, 'daysUntilStart' | 'daysRemaining' | 'status'>) {
  const daysInfo = planning.status === 'upcoming' ? planning.daysUntilStart : planning.daysRemaining
  const defaultLabel = planning.status.charAt(0).toUpperCase() + planning.status.slice(1)

  if (planning.status === 'past') return t`Past`

  if (daysInfo === null) return defaultLabel

  if (planning.status === 'active') {
    return t`Active (${daysInfo} days left)`
  }

  return t`Starts in ${daysInfo} days`
}

export function getPlanningOverviewCompletionColor(rate: number): string {
  if (rate >= 80) return '#4caf50' // success
  if (rate >= 50) return '#ff9800' // warning
  return '#f44336' // error
}
